var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"coinTable"}},[_c('CoinFlexTable',{attrs:{"headerValues":_vm.headerValues,"rowValues":_vm.rowValues,"rowColors":_vm.rowColors,"heightPercentage":_vm.heightPercentage},on:{"updateSortKeys":_vm.updateSortKeys}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }